/*
 * The possible states of the relationship of a person with a project
 *
 * \note Make sure to keep this up-to-date with the matching
 *       enums in the AWS lambda and the create-sample-data tool
 */
export enum OnProjectStatus {
  INACTIVE = 0,
  ON_PROJECT,
  AWAITING_CLIENT_APPROVAL,
  SUGGESTED,
  REFUSED_BY_CLIENT,
  AWAITING_PERSON_APPROVAL,
  REFUSED_BY_PERSON,
  PERSON_APPROVED,
  CLIENT_APPROVED,

}

/*
 * The userfriendly names of \ref OnProjectStatus when rendered as intervals / standalone
 */
export const OnProjectStatusNames: { [key in OnProjectStatus]: string } = {
  [OnProjectStatus.INACTIVE]: 'Inactive',
  [OnProjectStatus.ON_PROJECT]: 'On project',
  [OnProjectStatus.AWAITING_CLIENT_APPROVAL]: 'Awaiting client approval',
  [OnProjectStatus.SUGGESTED]: 'Suggested',
  [OnProjectStatus.REFUSED_BY_CLIENT]: 'Refused by client',
  [OnProjectStatus.AWAITING_PERSON_APPROVAL]: 'Awaiting person approval',
  [OnProjectStatus.REFUSED_BY_PERSON]: 'Refused by person',
  [OnProjectStatus.PERSON_APPROVED]: 'Person approved',
  [OnProjectStatus.CLIENT_APPROVED]: 'Client approved',
};

export const renderOnProjectStatus = (status: OnProjectStatus) => {
  const statusName = OnProjectStatusNames[status];
  return statusName !== undefined ? statusName : 'Unknown status';
};

/*
 * The userfriendly names of \ref OnProjectStatus when rendered as events
 */
export const OnProjectStatusNamesAsEvents: { [key in OnProjectStatus]: string } = {
  [OnProjectStatus.INACTIVE]: 'Leaves project',
  [OnProjectStatus.ON_PROJECT]: 'Joins project',
  [OnProjectStatus.AWAITING_CLIENT_APPROVAL]: 'Starts awaiting client approval',
  [OnProjectStatus.SUGGESTED]: 'Suggested for the project',
  [OnProjectStatus.REFUSED_BY_CLIENT]: 'Has been refused by the client',
  [OnProjectStatus.AWAITING_PERSON_APPROVAL]: 'Awaiting person approval',
  [OnProjectStatus.REFUSED_BY_PERSON]: 'Has been refused by person',
  [OnProjectStatus.PERSON_APPROVED]: 'Person has approved',
  [OnProjectStatus.CLIENT_APPROVED]: 'Client has approved',
};

export const renderOnProjectStatusAsEvent = (status: OnProjectStatus) => {
  const statusName = OnProjectStatusNamesAsEvents[status];
  return statusName !== undefined ? statusName : 'Unknown status';
};
